import { formatApiResponse } from '@utils/helpers';
import { protectedApi } from '@api';

export const getNotificationListAPI = async (page, limit, filters = {}) => {
  try {
    const { clinicId, type, startDate, endDate, isSeen } = filters;
    let url = `/notification/?page=${page}&limit=${limit}`;
    if (clinicId) url += `&clinic_id=${clinicId}`;
    if (type) url += `&type=${encodeURIComponent(type)}`;
    if (startDate) url += `&start_date=${startDate}`;
    if (endDate) url += `&end_date=${endDate}`;
    // isSeen: '' = all , '0' = unseen only , '1' = seen only
    if (isSeen === '0' || isSeen === '1') url += `&is_seen=${isSeen}`;
    const res = await protectedApi.get(url);
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

export const getNotificationCountAPI = async () => {
  try {
    const res = await protectedApi.get(`/notification/count/`);
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

/** Mark seen by notification row ids (all clinics; no clinic_id in URL). */
export const markNotificationsSeenAPI = async (ids) => {
  try {
    const response = await protectedApi.post(`/notification/is_seen/`, { ids });
    return formatApiResponse(response);
  } catch (error) {
    return formatApiResponse(error);
  }
};
